let forms = {
	ipf: {
		icon: 'fa fa-user',
		title: 'Request IPF',
		subtitle: 'Request bank ipf',
		forms: [
			// {
			//    type: 'select', class: 'col-12', model: 'bank', filterable: true, clearable: true,
			//    options: [], validation: 'required', label: 'Bank'
			// },
			{
				type: 'text',
				form_type: 'text',
				class: 'col-12',
				model: 'amount',
				validation: 'required|min:3|max:150|numeric',
				label: 'Amount',
				placeholder: 'Enter the amount',
			},
			{
				type: 'slider',
				step: 1,
				min: 1,
				max: 12,
				model: 'period',
				label: 'IPF Term',
				show_stops: true,
				class: 'col-12',
				validation: 'required',
			},
			{
				type: 'slider',
				step: 1,
				min: 1,
				max: 28,
				model: 'date',
				label: 'Preffered Payment Date',
				show_stops: true,
				class: 'col-12',
				validation: 'required',
			},
		],
	},
	ipfProduct: {
		icon: 'fa fa-user',
		title: 'Request IPF',
		subtitle: 'Request bank ipf',
		forms: [
			{
				type: 'select',
				class: 'col-12',
				model: 'product',
				filterable: true,
				clearable: true,
				options: [],
				validation: 'required',
				label: 'IPF Products',
			},
		],
	},
	ipfDate: {
		icon: 'fa fa-user',
		title: 'Request IPF',
		subtitle: 'Request bank ipf',
		forms: [
			{
				type: 'datepicker',
				form_type: 'date',
				format: 'dd-MM-yyyy',
				placement: 'bottom-end',
				placeholder: 'Select a start date',
				model: 'date',
				label: 'Start Duration',
				class: 'col-12',
				validation: 'required',
			},
		],
	},
	ipfPayment: {
		icon: 'fa fa-user',
		title: 'Request IPF',
		subtitle: 'Request bank ipf',
		forms: [
			{
				type: 'select',
				class: 'col-12',
				model: 'payment_option',
				filterable: true,
				clearable: true,
				options: [],
				validation: '',
				label: 'Payment Option',
			},
		],
	},
	ipfPay: {
		icon: 'fa fa-user',
		title: 'Pay IPF',
		subtitle: 'Pay bank ipf',
		forms: [
			// {
			//    type: 'select', class: 'col-12', model: 'account', filterable: true, clearable: true,
			//    options: [], validation: 'required', label: 'Account'
			// },
			{
				type: 'text',
				form_type: 'text',
				class: 'col-12',
				model: 'amount',
				validation: 'required|min:1|max:150|numeric',
				label: 'Amount',
				placeholder: 'Enter the amount',
			},
		],
	},
};

module.exports = {
	forms: utils.generateAllFormData(forms),
};
